import React from "react"
import Ample from "../components/ample"
import { OutboundLink } from "gatsby-plugin-google-gtag"



export default class PCRatiosPage extends React.Component {  
  explainerBlurb =<div>
  Here we chart the ratio of open option interet in puts vs. calls (a measure of the amount of caution in the market).  It is sometimes the case that when this ratio's trendline (or rolling average) 'rolls over' and starts a new trend, the overall stock market soon follows.  Overlaid in the backgroud is a plot of the daily closing price of SPY, a proxy for the <OutboundLink href="https://www.investopedia.com/terms/s/sp500.asp">S&P 500 index</OutboundLink>
  </div>  

  render() {
    return (
<Ample currPageTitle="Equity-only Put/Call Ratios" explainerBlurb={this.explainerBlurb}>
    <div className="row">
        <div className="col-md-12">
            <div className="white-box">
                <div className="box-title">Put/Call Ratios</div>
                <iframe 
                  src="https://content.harsip.com/bidask/market_data/pc_ratio_spx.html" 
                  border="0" width="800" height="600" 
                  style= {{border:`none`}}
                  title="Put/Call Ratios">
                    
                </iframe>
            </div>
        </div>
        </div>
  </Ample>
    )
  }
}

